// The normal account type that can perform write operations on policies, claims, etc
const DEPRECATED__EMPLOYEE__ACCOUNT_TYPE = 'account.tenant.employee';

// Cannot perform any type of write operation. Only has read access.
const DEPRECATED__READ_ONLY_USER__ACCOUNT_TYPE =
	'account.tenant.read.only.user';

const DEPRECATED__CLAIMS_ONLY_USER__ACCOUNT_TYPE =
	'account.tenant.claims.only.user';

export type Permission =
	| '*.*'
	| '*.fetch'
	| 'analytics.*'
	| 'analytics.fetch'
	| 'auxData.*'
	| 'auxData.delete'
	| 'auxData.fetch'
	| 'auxData.write'
	| 'calculation.*'
	| 'calculation.check'
	| 'cancellation.*'
	| 'cancellation.create'
	| 'cancellation.fetch'
	| 'cancellation.issue'
	| 'cancellation.rescind'
	| 'cancellation.update'
	| 'cashBalance.*'
	| 'cashBalance.fetch'
	| 'cashBalance.transfer'
	| 'cashBalanceLog.*'
	| 'cashBalanceLog.fetch'
	| 'catchUpInvoice.*'
	| 'catchUpInvoice.issue'
	| 'catchUpInvoice.fetch'
	| 'catchUpInvoice.writeOff'
	| 'claim.*'
	| 'claim.create'
	| 'claim.createPayable'
	| 'claim.discard'
	| 'claim.fetch'
	| 'claim.reversePayable'
	| 'claim.update'
	| 'deployment.*'
	| 'deployment.fetch'
	| 'disbursement.*'
	| 'disbursement.create'
	| 'disbursement.fetch'
	| 'disbursement.update'
	| 'document.*'
	| 'document.write'
	| 'endorsement.*'
	| 'endorsement.create'
	| 'endorsement.fetch'
	| 'endorsement.update'
	| 'endorsement.discard'
	| 'endorsement.issue'
	| 'endorsement.quote'
	| 'endorsement.accept'
	| 'endorsement.invalidate'
	| 'event.*'
	| 'event.fetch'
	| 'eventstream.*'
	| 'eventstream.fetch'
	| 'gracePeriod.*'
	| 'gracePeriod.fetch'
	| 'gracePeriod.update'
	| 'integration.*'
	| 'integration.fetch'
	| 'invoice.*'
	| 'invoice.fetch'
	| 'invoice.pay'
	| 'invoice.writeOff'
	| 'lambda.*'
	| 'lambda.write'
	| 'media.*'
	| 'media.fetch'
	| 'media.upload'
	| 'ontology.*'
	| 'ontology.fetch'
	| 'payment.*'
	| 'payment.create'
	| 'payment.fetch'
	| 'payment.update'
	| 'payment.reverse'
	| 'policy.*'
	| 'policy.addDocument'
	| 'policy.create'
	| 'policy.discard'
	| 'policy.fetch'
	| 'policy.issue'
	| 'policy.quote'
	| 'policy.removeDocument'
	| 'policy.update'
	| 'policy.paymentSchedule'
	| 'policy.fee'
	| 'policyholder.*'
	| 'policyholder.create'
	| 'policyholder.fetch'
	| 'policyholder.update'
	| 'premiumReport.*'
	| 'premiumReport.create'
	| 'premiumReport.discard'
	| 'premiumReport.fetch'
	| 'premiumReport.issue'
	| 'premiumReport.replace'
	| 'premiumReport.reverse'
	| 'premiumReport.update'
	| 'product.*'
	| 'product.fetch'
	| 'quote.*'
	| 'quote.accept'
	| 'quote.create'
	| 'quote.discard'
	| 'quote.fetch'
	| 'quote.invalidate'
	| 'quote.issue'
	| 'quote.quote'
	| 'quote.update'
	| 'reinstatement.*'
	| 'reinstatement.accept'
	| 'reinstatement.fetch'
	| 'reinstatement.issue'
	| 'reinstatement.invalidate'
	| 'reinstatement.create'
	| 'reinstatement.update'
	| 'renewal.*'
	| 'renewal.create'
	| 'renewal.fetch'
	| 'renewal.update'
	| 'renewal.discard'
	| 'renewal.issue'
	| 'renewal.quote'
	| 'renewal.accept'
	| 'renewal.invalidate'
	| 'report.*'
	| 'report.fetch'
	| 'search.*'
	| 'search.fetch'
	| 'scripts.*'
	| 'scripts.fetch'
	| 'tenant.*'
	| 'tenant.fetch'
	| 'webhook.*'
	| 'webhook.fetch'
	| 'workflow.*'
	| 'workflow.fetch'
	| 'workflow.invalidate';

export const permissions: PermissionsKeyedShape = {
	global: ['*.*', '*.fetch'],
	analytics: ['analytics.*', 'analytics.fetch'],
	auxData: ['auxData.*', 'auxData.fetch', 'auxData.write', 'auxData.delete'],
	calculation: ['calculation.*', 'calculation.check'],
	cancellation: [
		'cancellation.*',
		'cancellation.fetch',
		'cancellation.update',
		'cancellation.create',
		'cancellation.issue',
		'cancellation.rescind',
	],
	cashBalance: ['cashBalance.*', 'cashBalance.fetch', 'cashBalance.transfer'],
	cashBalanceLog: ['cashBalanceLog.*', 'cashBalanceLog.fetch'],
	catchUp: [
		'catchUpInvoice.*',
		'catchUpInvoice.fetch',
		'catchUpInvoice.issue',
		'catchUpInvoice.writeOff',
	],
	claim: [
		'claim.*',
		'claim.fetch',
		'claim.update',
		'claim.create',
		'claim.discard',
		'claim.createPayable',
		'claim.reversePayable',
	],
	deployment: ['deployment.*', 'deployment.fetch'],
	disbursement: [
		'disbursement.*',
		'disbursement.fetch',
		'disbursement.update',
		'disbursement.create',
	],
	document: ['document.*', 'document.write'],
	endorsement: [
		'endorsement.*',
		'endorsement.fetch',
		'endorsement.update',
		'endorsement.create',
		'endorsement.discard',
		'endorsement.issue',
		'endorsement.quote',
		'endorsement.accept',
		'endorsement.invalidate',
	],
	event: ['event.*', 'event.fetch'],
	eventstream: ['eventstream.*', 'eventstream.fetch'],
	gracePeriod: ['gracePeriod.*', 'gracePeriod.fetch', 'gracePeriod.update'],
	integration: ['integration.*', 'integration.fetch'],
	invoice: ['invoice.*', 'invoice.fetch', 'invoice.pay', 'invoice.writeOff'],
	lambda: ['lambda.*', 'lambda.write'],
	media: ['media.*', 'media.fetch', 'media.upload'],
	ontology: ['ontology.*', 'ontology.fetch'],
	payment: [
		'payment.*',
		'payment.fetch',
		'payment.update',
		'payment.create',
		'payment.reverse',
	],
	policy: [
		'policy.*',
		'policy.fetch',
		'policy.update',
		'policy.create',
		'policy.quote',
		'policy.issue',
		'policy.addDocument',
		'policy.removeDocument',
		'policy.discard',
		'policy.paymentSchedule',
		'policy.fee',
	],
	policyholder: [
		'policyholder.*',
		'policyholder.fetch',
		'policyholder.update',
		'policyholder.create',
	],
	premiumReport: [
		'premiumReport.*',
		'premiumReport.fetch',
		'premiumReport.update',
		'premiumReport.create',
		'premiumReport.issue',
		'premiumReport.discard',
		'premiumReport.reverse',
		'premiumReport.replace',
	],
	product: ['product.*', 'product.fetch'],
	quote: [
		'quote.*',
		'quote.fetch',
		'quote.update',
		'quote.create',
		'quote.quote',
		'quote.accept',
		'quote.invalidate',
		'quote.discard',
	],
	reinstatement: [
		'reinstatement.*',
		'reinstatement.fetch',
		'reinstatement.update',
		'reinstatement.create',
		'reinstatement.issue',
		'reinstatement.accept',
		'reinstatement.invalidate',
	],
	renewal: [
		'renewal.*',
		'renewal.fetch',
		'renewal.update',
		'renewal.create',
		'renewal.discard',
		'renewal.issue',
		'renewal.quote',
		'renewal.accept',
		'renewal.invalidate',
	],
	report: ['report.*', 'report.fetch'],
	scripts: ['scripts.*', 'scripts.fetch'],
	search: ['search.*', 'search.fetch'],
	tenant: ['tenant.*', 'tenant.fetch'],
	webhook: ['webhook.*', 'webhook.fetch'],
	workflow: ['workflow.*', 'workflow.fetch'],
};

export interface PermissionsKeyedShape {
	global: Permission[];
	analytics: Permission[];
	auxData: Permission[];
	calculation: Permission[];
	cancellation: Permission[];
	cashBalance: Permission[];
	cashBalanceLog: Permission[];
	catchUp: Permission[];
	claim: Permission[];
	deployment: Permission[];
	disbursement: Permission[];
	document: Permission[];
	endorsement: Permission[];
	event: Permission[];
	eventstream: Permission[];
	gracePeriod: Permission[];
	integration: Permission[];
	invoice: Permission[];
	lambda: Permission[];
	media: Permission[];
	ontology: Permission[];
	payment: Permission[];
	policy: Permission[];
	policyholder: Permission[];
	premiumReport: Permission[];
	product: Permission[];
	quote: Permission[];
	reinstatement: Permission[];
	renewal: Permission[];
	report: Permission[];
	scripts: Permission[];
	search: Permission[];
	tenant: Permission[];
	webhook: Permission[];
	workflow: Permission[];
}

type PermissionDisplayName = (
	permission: Permission,
	config?: {
		excludeScope?: boolean;
		excludeAction?: boolean;
	},
) => string;

export const permissionDisplayName: PermissionDisplayName = (
	permission: Permission,
	config = {
		excludeScope: false,
		excludeAction: false,
	},
) => {
	let displayScope = '';
	let displayAction = '';
	const [scope, permissableAction] = permission.split('.');

	if (scope === '*') {
		displayScope = 'Global';
	} else {
		displayScope = scope.split(/(?=[A-Z])/).join(' ');
	}

	if (permissableAction === '*') {
		displayAction = 'All';
	} else {
		displayAction = permissableAction.split(/(?=[A-Z])/).join(' ');
	}

	const capitalizedScope =
		displayScope.charAt(0).toUpperCase() + displayScope.slice(1);
	const capitalizedAction =
		displayAction.charAt(0).toUpperCase() + displayAction.slice(1);

	if (config.excludeScope && config.excludeAction) {
		return '';
	}

	if (config.excludeScope) {
		return capitalizedAction;
	}

	if (config.excludeAction) {
		return capitalizedScope;
	}

	const permissionName = capitalizedScope + ' ' + capitalizedAction;

	return permissionName;
};

interface LegacyPermissions {
	[DEPRECATED__READ_ONLY_USER__ACCOUNT_TYPE]: Permission[];
	[DEPRECATED__CLAIMS_ONLY_USER__ACCOUNT_TYPE]: Permission[];
	[DEPRECATED__EMPLOYEE__ACCOUNT_TYPE]: Permission[];
}

export const legacyPermissions: LegacyPermissions = {
	[DEPRECATED__READ_ONLY_USER__ACCOUNT_TYPE]: ['*.fetch'],
	[DEPRECATED__CLAIMS_ONLY_USER__ACCOUNT_TYPE]: [
		'auxData.fetch',
		'calculation.check',
		'claim.*',
		'cancellation.fetch',
		'document.write',
		'endorsement.fetch',
		'event.fetch',
		'eventstream.fetch',
		'gracePeriod.fetch',
		'invoice.fetch',
		'media.*',
		'ontology.fetch',
		'policy.fetch',
		'policy.quote',
		'policyholder.fetch',
		'premiumReport.fetch',
		'product.fetch',
		'quote.fetch',
		'quote.quote',
		'reinstatement.fetch',
		'renewal.fetch',
		'search.fetch',
		'tenant.fetch',
		'workflow.fetch',
	],
	[DEPRECATED__EMPLOYEE__ACCOUNT_TYPE]: ['*.*'],
};
